import { useEffect, useState } from 'react';

export default function PriceCounter() {
  const [elapsedTime, setElapsedTime] = useState(0); // seconds
  const [isRunning, setIsRunning] = useState(false);
  const [hourlyPrice, setHourlyPrice] = useState(30); // default to €30
  const [livePrice, setLivePrice] = useState(0);

  // Start stopwatch
  useEffect(() => {
    let intervalId: NodeJS.Timeout;

    if (isRunning) {
      intervalId = setInterval(() => {
        setElapsedTime(prev => prev + 1);
      }, 1000);
    }

    return () => clearInterval(intervalId);
  }, [isRunning]);

  const display = document.getElementById('stopwatch');
  const start = performance.now();

  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function update(time) {
    const totalSeconds = Math.floor((time - start) / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (!display) return;
    display.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;

    requestAnimationFrame(update);
  }

  useEffect(() => {
    requestAnimationFrame(update);
  }, []);

  // Update live price every second or when hourly price changes
  useEffect(() => {
    setLivePrice((elapsedTime / 3600) * hourlyPrice);
  }, [elapsedTime, hourlyPrice]);

  return (
    <div style={{ fontFamily: 'sans-serif', padding: '1rem' }}>
      <h2>Live Price Counter</h2>

      <p><strong>Elapsed Time:</strong> {elapsedTime} seconds</p>
      <p><strong>Hourly Rate:</strong> €{hourlyPrice}</p>
      <p><strong>Live Price:</strong> €{livePrice.toFixed(2)}</p>

      <div style={{ marginTop: '1rem' }}>
        <button onClick={() => setIsRunning(prev => !prev)}>
          {isRunning ? 'Pause' : 'Start'}
        </button>
        <button onClick={() => setElapsedTime(0)} style={{ marginLeft: '0.5rem' }}>
          Reset
        </button>
      </div>

      <div style={{ marginTop: '1rem' }}>
        <p>Select Hourly Price:</p>
        <button onClick={() => setHourlyPrice(30)}>€30</button>
        <button onClick={() => setHourlyPrice(50)} style={{ marginLeft: '0.5rem' }}>€50</button>
        <button onClick={() => setHourlyPrice(75)} style={{ marginLeft: '0.5rem' }}>€75</button>
      </div>

      <div id="stopwatch">00:00:00</div>

    </div>
  );
}
